export default "__VITE_ASSET__CHpHB_aE__"